module.exports = __webpack_public_path__ + "img/confirm_content_bg.3f9589b5.png";